var SCM = SCM || {};

/** A facility for working with Z encoding. */
SCM.ZEncoderV1 = (function () {
    /*                                                                                                 *
     *     _JS implementation_ of the forward encoding for the ZEncoderV1 scheme.                      *
     *     This should be kept in sync with the C# implementation:                                     *
     *                                                                                                 *
     *           C:\Projects\scm\Client\OUP\OUP.Web\IocImplementations\Sigma\ZEncoder\ZEncoderV1.cs    *
     *                                                                                                 */

    // See the C# version for a discussion of the format and general documentation.
    // Example: SCM.ZEncoderV1.Encode('a string') => 'azistring'
    var specialChars = [
        ':', '"', '\'', ',', '[', ']', '{', '}', ' ', '/',
        '!', '#', '$', '&', '(', ')', '+', '=', '?', '@', 
        '*', '%', '.', '_', '-'
    ];

    // build forward dictionary for special characters
    var forward = (function () {
        var res = {};
        for (var i = 0; i < specialChars.length; i++) {
            res[specialChars[i]] = String.fromCharCode(
                'a'.charCodeAt(0) + i
            );
        }
        return res;
    })();

    var backward = (function() {
        res = {};
        $.each(forward, function( k, v ) {
            res[v] = k;
        });
        return res;
    })();


    function IsSafe(ch) {
        // excepting the 'z', these are characters that are left unchanged by Z encoding.  
        return (ch >= 'a' && ch <= 'z')
            || (ch >= 'A' && ch <= 'Z')
            || (ch >= '0' && ch <= '9');
    }

    // Convert a string into a series of padded hex digits
    // representing the UTF-16 code units.  
    function HexEncode(str) {
        // adapted from https://stackoverflow.com/a/21648161/2366407
        var hex, i;
        var result = "";
        for (i = 0; i < str.length; i++) {
            hex = str.charCodeAt(i).toString(16);
            result += ("000" + hex).slice(-4);
        }
        return result;
    }

    // do the actual encoding
    function Encode(str) {
        // Return an empty string if the input is empty or invalid (e.g., null).
        if (!str) return "";

        var res = "";
        for (var i = 0; i < str.length; i++) {
            var ch = str[i];
            if (ch === 'z') {
                res += "zz";
            }
            else if (IsSafe(ch)) {
                res += ch;
            }
            else {
                res += 'z';
                if (forward.hasOwnProperty(ch)) {
                    res += forward[ch];
                }
                else {
                    // already padded
                    var hex = HexEncode(ch);
                    res += hex;
                }
            }
        }
        return res;
    }
    
    function Decode(str) {
        // Return an empty string if the input is empty or invalid (e.g., null).
        if (!str) return "";

        var res = "";
        for (var i = 0; i < str.length; i++)
        {
            var ch = str[i];

            if (ch === "z")
            {
                if (i === str.Length - 1) {
                    return "";
                }
                else if (str[i + 1] === "z")
                {
                    res += "z";
                    i++; // skip next z
                    continue;
                }
                else if (str[i + 1] in backward)
                {
                    res += (backward[str[i + 1]]);
                    i++; // skip special char
                    continue;
                }
                else if (i >= str.length - 4) {
                    return "";
                }
                var digits = str.substring(i + 1, 4);
                if (typeof digits !== 'number') {
                    return "";
                }
                res += digits;
                i += 4; // skip digits
                continue;
            }
            else
            {
                // normal character
                res += ch;
            }
        }
        return res;
    }

    return {
        /** Return a Z-encoded version of the specified string. */
        Encode: Encode,
        Decode: Decode
    };
    
})();
